import React from "react";
import Button from "@mui/material/Button";
import CameraIcon from "@mui/icons-material/PhotoCamera";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import Aboutuscomponent from "./Aboutcomponent";
import { height } from "@mui/system";

const theme = createTheme();

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14 , 15,16,17];

const crewDetails = [
  {
    name:"Mr.R.Raja Subramanian",
    role:"Founder",
    github:"",
    linkedin:"",
    image:"https://drive.google.com/uc?export=view&id=1WqF2opnyrrMwYBLTSc4aW7LWqVPTp5-V",
  },
  {
    name:"Ms Karuna Lakhani",
    role:"Industry Mentor",
    github:"",
    linkedin:"",
    image:"https://avatars.githubusercontent.com/u/5897153?v=4",
  },
  {
    name:"Marisetty Sai Murali",
    role:"President",
    github:"https://github.com/SaiMuraliRoyal",
    linkedin:"https://www.linkedin.com/in/sai-murali-marisetty-12175b11b/",
    image:"https://drive.google.com/uc?export=view&id=1wl6OK8c_pIqvLUGHynr7YsMt33NgH0eo",
  },
  {
    name:"Nukala Akshith",
    role:"Vice President",
    github:"https://github.com/Akshith-github",
    linkedin:"https://www.linkedin.com/in/nukala-akshith-642b641a5",
    image:"https://drive.google.com/uc?export=view&id=1ok7V_nTgR-cx0_C6gBy_KfcPWyjLq2bK",
  },
  {
    name:"Yalla Sireesha",
    role:"Treasurer",
    github:"https://github.com/YALLASIREESHA",
    linkedin:"https://www.linkedin.com/in/yalla-sireesha-5ba4321b2/",
    image:"https://drive.google.com/uc?export=view&id=1rGajKGpEcuOb2dG4mZ83dDrTMEUjeK0M",
  },
  {
    name:"Dintakurthi Achuth",
    role:"Secretary",
    github:"",
    linkedin:"",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVk96KX0FEh-9naujW0wOS6IoXcXPnhC4d_TAy-Rphjxy7zKUvDl7aZNWMkCJdZ4hMCgo&usqp=CAU",
  },
  {
    name:"M.Lavanya",
    role:"Student Coordinator",
    github:"https://github.com/lavanya1329",
    linkedin:"http://www.linkedin.com/in/lavanya-murugan-92b4531b2",
    image:"https://drive.google.com/uc?export=view&id=1nWK4wPQzIWrRRXZBycDhWG9Y2Z56dwV0",
  },
  {
    name:"K.Poojitha",
    role:"Student Coordinator",
    github:"https://github.com/poojitaketepalli",
    linkedin:"http://www.linkedin.com/in/ketepalli-poojita-lakshmi-syamala-a1ba531a4",
    image:"https://drive.google.com/uc?export=view&id=1hfwB7yZ5GOUrdvxYClc0r_MpYGDVtMEe",
  },
  {
    name:"S.Aravind Babu",
    role:"Event Coordinator",
    github:"",
    linkedin:"",
    image:"https://drive.google.com/uc?export=view&id=1LkB4mFHnEfB0PV_3SjiFdR0ZvdnFlGOc",
  },
  {
    name:"D.Tanouz",
    role:"Events Coordinator",
    github:"",
    linkedin:"",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSJJ3AG0q1d3_MhTwuiHh0nh4EC_sXeMKMYL3csjE896GjIF4Ci41DOFCdEa1GX-lUb60c&usqp=CAU",
  },
  {
    name:"M.Abhiram",
    role:"Student Coordinator-Project Development",
    github:"https://github.com/Abhiram26prog",
    linkedin:"https://www.linkedin.com/in/madhurapantula-abhiram-5946341a6",
    image:"https://drive.google.com/uc?export=view&id=1mK4lRlTn_oqflpXjWpjgqfxQ_K-LPRqV",
  },
  {
    name:"V.Rama Krishna",
    role:"Student Coordinator-Project Development",
    github:"https://github.com/RamaKrishna42",
    linkedin:"https://www.linkedin.com/in/rama-krishna-vedala-a9566a193/",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVk96KX0FEh-9naujW0wOS6IoXcXPnhC4d_TAy-Rphjxy7zKUvDl7aZNWMkCJdZ4hMCgo&usqp=CAU",
  },
  {
    name:"M.Devendra Reddy",
    role:"Student Coordinator-Research Oriented",
    github:"https://github.com/Musalappagaridevendrareddy",
    linkedin:"https://www.linkedin.com/in/musalappagari-devendrareddy-drbu/",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVk96KX0FEh-9naujW0wOS6IoXcXPnhC4d_TAy-Rphjxy7zKUvDl7aZNWMkCJdZ4hMCgo&usqp=CAU",
  },
  {
    name:"Prudhvi Deepak",
    role:"Student Coordinator-Research Oriented",
    github:"https://github.com/Prudhivi-Deepak",
    linkedin:"https://www.linkedin.com/in/deepak-prudhivi-bb37071a5",
    image:"https://drive.google.com/uc?export=view&id=1EE90CgiFX2pMy2s1br_x81uNOSb_ga4W",
  },
  {
    name:"B.Kusuma",
    role:"Media Committie member",
    github:"https://github.com/kusuma0511",
    linkedin:"https://www.linkedin.com/in/bendela-kusuma-b95b371b2",
    image:"https://drive.google.com/uc?export=view&id=1vnqG6XKOxMcKQrEl0ZZBL9LB3GFm_MVj",
  },
  {
    name:"G.Narasamiha Murthy",
    role:"Media Committie member",
    github:"",
    linkedin:"",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVk96KX0FEh-9naujW0wOS6IoXcXPnhC4d_TAy-Rphjxy7zKUvDl7aZNWMkCJdZ4hMCgo&usqp=CAU",
  },
  {
    name:"Mekala Harika",
    role:"Media Committie member",
    github:"",
    linkedin:"",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVk96KX0FEh-9naujW0wOS6IoXcXPnhC4d_TAy-Rphjxy7zKUvDl7aZNWMkCJdZ4hMCgo&usqp=CAU",
  },
  {
    name:"Deepak Balusa",
    role:"Media Committie member",
    github:"",
    linkedin:"",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVk96KX0FEh-9naujW0wOS6IoXcXPnhC4d_TAy-Rphjxy7zKUvDl7aZNWMkCJdZ4hMCgo&usqp=CAU",
  },
  {
    name:"Pranav Nadh",
    role:"Media Committie member",
    github:"",
    linkedin:"",
    image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQVk96KX0FEh-9naujW0wOS6IoXcXPnhC4d_TAy-Rphjxy7zKUvDl7aZNWMkCJdZ4hMCgo&usqp=CAU",
  },

];

function Aboutcrew() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />a
      <main>
        {/* Hero unit */}
        <Aboutuscomponent />
        <Box
          sx={{
            pt: 8,
            pb: 6,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img style={{ width: "400px", height: "400px" }} src="pp.jpeg" />
          </div>
        </Box>
        <Container maxWidth="sm">
          <Typography variant="h6" color="text.secondary" paragraph>
            ❝Kare Oss works under the guidence of Prof.R.Raja Subramanian, Dept
            of Computer science and Engg,KARE!❞
          </Typography>
        </Container>
        <Container sx={{ display: "flex", justifyContent: "center" }}>
          <Card sx={{ maxWidth: 500 , bgcolor: "lightgrey"}}>
            <CardContent>
              <Typography
                component="h2"
                variant="h3"
                align="center"
                gutterBottom
                style={{ fontWeight: "bold"  }}
                color="text.primary"
                paragraph
              >
                Meet The Crew
              </Typography>
              <Typography variant="h6" color="text.secondary" align="center" paragraph>
                ❝Team work divides the task and Multiplies the Success❞
              </Typography>
            </CardContent>
          </Card>
        </Container>
        <Container sx={{ py: 8 }} maxWidth="md">
          {/* End hero unit */}
          <Grid container spacing={4}>
            {crewDetails.map((cards) => (
              <Grid item key={cards} xs={12} sm={6} md={4}>
                <Card
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardMedia
                    component="img"
                    width="300"
                    height="400"
                    image={cards.image}
                    alt="random"
                  />
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Typography gutterBottom variant="h5" component="h2">
                      {cards.name}
                    </Typography>
                    <Typography>{cards.role}</Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" href={cards.github}>Github</Button>
                    <Button size="small" href={cards.linkedin}>Linked In</Button>
                  </CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Container>
      </main>
    </ThemeProvider>
  );
}

export default Aboutcrew;
